// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__fR1EA"};